export default __webpack_public_path__ + "static/media/IMG-20241005-WA0025.9cba1b3d.jpg";